// Etiquetas legibles de campo · T-15 (ANEXO-AUDITORIA-01)
//
// UNA sola fuente para traducir el nombre técnico de una columna a la
// palabra que usa la gente: `telegram_chat_id` → «Telegram»,
// `telefono_personal` → «Teléfono personal». La pantalla nunca pinta el
// nombre crudo; lo pinta a través de `etiquetaCampo`. Vive aquí, suelto y
// sin React, para poder probarlo, y con caída legible cuando falta una
// palabra: se humaniza el código (guiones bajos a espacios, primera en
// mayúscula), nunca se oculta el campo.
//
// El ESPEJO de roles vive en `lib/roles.js` (`etiquetaRol`), que ya
// existía; éste es su gemelo para los campos. Mismas palabras para las
// mismas cosas: si un campo ya tiene nombre en la bitácora, es el mismo
// nombre en «Mis datos» y en cualquier otra pantalla.
export const ETIQUETA_CAMPO = {
  // Identidad y contacto de la persona.
  nombre: 'Nombre',
  nombre_completo: 'Nombre',
  email: 'Correo',
  telefono: 'Teléfono',
  telefono_personal: 'Teléfono personal',
  correo_recuperacion: 'Correo de recuperación',
  telegram_chat_id: 'Telegram',
  curp: 'CURP',
  nombre_usuario: 'Usuario',
  password_hash: 'Contraseña',
  pin_hash: 'PIN',
  totp_secret: 'Segundo factor',
  rol: 'Puesto',
  activo: 'Activo',

  // «Lo que hiciste»: los conteos de la ficha de datos personales.
  sesiones: 'Sesiones',
  fichajes: 'Fichajes',
  notificaciones: 'Notificaciones',
  acciones_en_bitacora: 'Acciones en la bitácora',

  // Inventario y bitácora (venían de la tabla de la Auditoría).
  sku: 'Código',
  codigo: 'Código',
  cantidad: 'Cantidad',
  precio_venta: 'Precio de venta',
  costo_promedio: 'Costo promedio',
  stock_minimo: 'Stock mínimo',
  punto_reorden: 'Punto de reorden',
  id_ubicacion: 'Ubicación',
  id_ubicacion_origen: 'Desde',
  id_ubicacion_destino: 'Hacia',
  id_producto: 'Producto',
  id_usuario: 'Persona',
  motivo: 'Motivo',
  referencia: 'Referencia',
  tipo: 'Tipo',
  estado: 'Estado',
  fecha: 'Fecha',
  descripcion: 'Descripción',
  unidad_medida: 'Unidad',
  decision: 'Decisión',
};

// Un código sin traducción no se oculta: se humaniza. `id_ubicacion` que no
// estuviera en el mapa saldría «Id ubicacion», legible, nunca en blanco.
function humanizar(campo) {
  const palabras = String(campo || '').toLowerCase().split('_').filter(Boolean);
  if (!palabras.length) return '—';
  const texto = palabras.join(' ');
  return texto.charAt(0).toUpperCase() + texto.slice(1);
}

/** `telegram_chat_id` → «Telegram»; un campo sin mapa se humaniza. */
export function etiquetaCampo(campo) {
  return ETIQUETA_CAMPO[campo] || humanizar(campo);
}
